import { apiClient } from '../client'
import { Agent, AgentPermission, ReassignAgentPayload, UpdateAgentPayload, UpdateCurrentAgentSettingsPayload } from './types'

export const getAgents = async (): Promise<Agent[]> => {
    const response = await apiClient('v1/core/agents')
    return response.data
}

export const getAgentById = async (id: string | number): Promise<Agent> => {
    const response = await apiClient(`v1/core/agents/${id}`)
    return response.data
}

export const updateAgent = async ({ agentId, data }: UpdateAgentPayload): Promise<Agent> => {
    const response = await apiClient(`v1/core/agents/${agentId}`, {
        method: 'PUT',
        data,
    })
    return response.data
}

export const updateCurrentAgentSettings = async ({ agentId, userSettings }: UpdateCurrentAgentSettingsPayload): Promise<void> => {
    await apiClient(`v1/core/agents/${agentId}`, {
        method: 'PUT',
        data: { userSettings: JSON.stringify(userSettings) },
    })
}

export const reassignAgent = async ({ agentId, ids, dataKey, urlBase }: ReassignAgentPayload): Promise<void> => {
    await apiClient(`v1/${urlBase}/agent/${agentId}`, {
        method: 'PUT',
        data: { [dataKey]: ids },
    })
}

export const getAgentPermissions = async (): Promise<AgentPermission[]> => {
    const response = await apiClient('v1/core/agent-permissions')
    return response.data
}
